import { IResponseState } from "../../../../components/Modals/ResponseModal/module/constants";
import { STATE_IDENTIFIER } from "./constants";

const {
  STEP_ONE,
    PROPAGATIONS,
    DEL_STATE,
    ADD_EDIT_STATE,
} = STATE_IDENTIFIER

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  [STEP_ONE]: {
    [PROPAGATIONS]: [],
    [DEL_STATE]: IResponseState.PENDING,
    [ADD_EDIT_STATE]: IResponseState.PENDING,
  }
};